import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Pen: BleskIcon = forwardRef(function Pen(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.88298V13H14.117L20.717 6.50798C21.113 6.11798 21.116 5.48098 20.723 5.08798L18.911 3.27598C18.518 2.88298 17.88 2.88598 17.491 3.28198L11 9.88298Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13H5C3.895 13 3 13.895 3 15V15C3 16.105 3.895 17 5 17H19C20.105 17 21 17.895 21 19V19C21 20.105 20.105 21 19 21H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
